module.exports = __webpack_public_path__ + "img/icons8-github.e9fac128.svg";